import React from 'react'
import * as styles from './advantagesCard.module.css'
import Svg1 from '../../images/svg/interactivity.svg'
import Svg2 from '../../images/svg/glow.svg'
import Svg3 from '../../images/svg/startup.svg'

const AdvantCard = (props) => {
  return (
    <div className={`${styles.card} ${props.className}`}>
      {props.data.svg === 1 && <Svg1 />}
      {props.data.svg === 2 && <Svg2 />}
      {props.data.svg === 3 && <Svg3 />}
      <span>{props.data.title}</span>
      <span>{props.data.body}</span>
    </div>
  )
}

export default AdvantCard
